import { useState } from "react";
import PropTypes from "prop-types";
import { Tabs, Button } from "@/config/antd";
import ScheduleTab from "@/pages/event_management/single_sub_event/components/sub_event_schedule_tabs/Schedule_Tab";
import ScheduleDialog from "@/components/shared/dialogs/Schedule_Dialog/Schedule_Dialog";
import "@/assets/styles/custom_tabs.css";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const ScheduleSection = ({ schedule, onScheduleSuccess, onScheduleError }) => {
  const [isScheduleDialogVisible, setIsScheduleDialogVisible] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [dialogMode, setDialogMode] = useState("add");
  const { id } = useParams();

  // Get the subEvent data from Redux store only once - don't trigger re-renders
  const subEvents = useSelector((state) => state.subEvent.subEvents);
  const currentSubEvent = subEvents.find((event) => event._id === id);

  // Get the latest schedule from Redux or fall back to props
  const currentSchedule = currentSubEvent?.schedule || schedule;

  const handleAddSchedule = () => {
    setDialogMode("add");
    const emptySchedule = {
      name: "",
      speakers: [],
      duration: {
        startTime: "",
        endTime: "",
      },
      // Pass the subEventId so the dialog knows which sub-event to update
      _id: id,
    };
    setSelectedSchedule(emptySchedule);
    setIsScheduleDialogVisible(true);
  };

  const handleScheduleSuccess = (mode, data) => {
    // Close the dialog
    setIsScheduleDialogVisible(false);

    // Call the parent success handler
    if (onScheduleSuccess) {
      onScheduleSuccess(mode, data);
    }
  };

  const handleScheduleError = (mode, errorMsg) => {
    console.error(
      `Schedule ${mode === "add" ? "add" : "update"} failed:`,
      errorMsg
    );

    // Call the parent error handler
    if (onScheduleError) {
      onScheduleError(mode, errorMsg);
    }
  };

  const items = [
    {
      label: "Event Schedule",
      key: "1",
      children: (
        <ScheduleTab
          schedules={currentSchedule}
          onScheduleSuccess={handleScheduleSuccess}
          onScheduleError={handleScheduleError}
        />
      ),
    },
  ];

  const operations = (
    <Button
      type="link"
      className="text-primary font-medium px-0"
      onClick={handleAddSchedule}>
      Add More
    </Button>
  );

  return (
    <div className="mt-8">
      <Tabs
        defaultActiveKey="1"
        items={items}
        tabBarExtraContent={{ right: operations }}
        className="custom-tabs"
      />
      <ScheduleDialog
        isVisible={isScheduleDialogVisible}
        onClose={() => setIsScheduleDialogVisible(false)}
        schedule={selectedSchedule}
        dialogMode={dialogMode}
        onSuccess={handleScheduleSuccess}
        onError={handleScheduleError}
      />
    </div>
  );
};

ScheduleSection.propTypes = {
  schedule: PropTypes.array,
  onScheduleSuccess: PropTypes.func,
  onScheduleError: PropTypes.func,
};

export default ScheduleSection;
